import React, { useState, useEffect } from 'react';
import { motion } from "framer-motion";
import './DrinkCarousel.css';

const products = [
    { id: 1, image: '/images/frappuccino.webp', name: 'frappuccino' },
    { id: 2, image: '/images/blue mojito.webp', name: 'blue mojito' },
    { id: 3, image: '/images/cappuccino.webp', name: 'cappuccino' },
    { id: 4, image: '/images/chaud.webp', name: 'chaud' },
    { id: 5, image: '/images/ice macchiato.webp', name: 'ice macchiato' },
    { id: 6, image: '/images/red mojito.webp', name: 'red mojito' },
    { id: 7, image: '/images/royal.webp', name: 'royal' },
];

const DrinkCarousel = () => {
    const [index, setIndex] = useState(0);

    const nextProduct = () => {
        setIndex((prevIndex) => (prevIndex + 1) % products.length);
    };

    const prevProduct = () => {
        setIndex((prevIndex) =>
            prevIndex === 0 ? products.length - 1 : prevIndex - 1
        );
    };

    // Auto-slide functionality
    useEffect(() => {
        const interval = setInterval(() => {
            nextProduct();
        }, 3000); // Slide every 3 seconds

        return () => clearInterval(interval); // Cleanup interval on unmount
    }, [index]); // Re-run effect when index changes

    return (
        <div className="carousel">
            <button className="nav-btn left" onClick={prevProduct}>
                ◀
            </button>
            <div className="carousel-container">
                {products.map((product, i) => {
                    const offsetRaw = i - index;
                    let offset = offsetRaw;
                    // Adjust offset for circular carousel
                    if (offset > Math.floor(products.length / 2)) {
                        offset -= products.length;
                    } else if (offset < -Math.floor(products.length / 2)) {
                        offset += products.length;
                    }

                    // Only display the current, previous, and next items
                    if (Math.abs(offset) > 1) return null;

                    const isCenter = offset === 0;

                    return (
                        <motion.div
                            key={product.id}
                            className="carousel-item"
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{
                                opacity: isCenter ? 1 : 0.5,
                                scale: isCenter ? 1 : 0.7, // Smaller scale for left and right items
                                x: offset * 300, // Reduced spacing
                            }}
                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                        >
                            <img src={product.image} alt={product.name} decoding="async" />
                        </motion.div>
                    );
                })}
            </div>
            <button className="nav-btn right" onClick={nextProduct}>
                ▶
            </button>
        </div>
    );
};

export default DrinkCarousel;